<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

    <ng-container *ngIf="consulta">

        <ul class="card-list-striped">
            <li>
                <span class="text-secondary">Placa</span>
                <span>{{consulta?.placa || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Chassi</span>
                <span>{{consulta?.chassi || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Renavam</span>
                <span>{{consulta?.renavam || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Município</span>
                <span>{{consulta?.municipio || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Espécie</span>
                <span>{{consulta?.especie || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Tipo</span>
                <span>{{consulta?.tipo || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Ano Fabricação</span>
                <span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Modelo</span>
                <span>{{consulta?.modelo || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Marca</span>
                <span>{{consulta?.marca || "NÃO INFORMADO"}}</span>
            </li>
        </ul>

        <div class="card-msg d-flex flex-column bg-white text-dark text-center" *ngIf="texto!=null">
            {{texto}}
        </div>

        <ng-container *ngIf="texto==null">
            <div  *ngFor="let m of consulta.listaDadosBatidas; let i = index" >
                <h2 class="subtitle subtitle-danger">BATIDA - COD. {{m?.codigo || "NÃO INFORMADO"}}</h2>
                <ul class="card-list-striped">
                    <li>
                        <span class="text-secondary">Município</span>
                        <span>{{m?.municipio || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">Data ocorrência </span>
                        <span>{{m?.dataAcidente || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">Tipo</span>
                        <span>{{m?.tipo || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">Grau de avaria </span>
                        <span>{{m?.grauAvaria || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">Resultado</span>
                        <span>{{m?.resultado || "NÃO INFORMADO"}}</span>
                    </li>
                </ul>
            </div>
        </ng-container>

    </ng-container>

</app-card-consulta>
